import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=c80eeefe&scoped=true"
import script from "./feedBack.vue?vue&type=script&lang=js"
export * from "./feedBack.vue?vue&type=script&lang=js"
import style0 from "./feedBack.vue?vue&type=style&index=0&id=c80eeefe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80eeefe",
  null
  
)

export default component.exports